import { Badge } from "@mantine/core";

export interface BooleanBadgeProps {
  value: boolean | null | undefined;
  /** Labels for true/false states. Default: ["Active", "Inactive"] */
  labels?: [string, string];
  /** Colors for true/false states. Default: ["green", "gray"] */
  colors?: [string, string];
  /** Badge variant for true state. Default: "filled" */
  trueVariant?: "filled" | "light" | "outline" | "dot";
  /** Badge variant for false state. Default: "light" */
  falseVariant?: "filled" | "light" | "outline" | "dot";
  /** Badge size */
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

export function BooleanBadge({
  value,
  labels = ["Active", "Inactive"],
  colors = ["green", "gray"],
  trueVariant = "filled",
  falseVariant = "light",
  size,
}: BooleanBadgeProps) {
  return (
    <Badge
      variant={value ? trueVariant : falseVariant}
      color={value ? colors[0] : colors[1]}
      size={size}
    >
      {value ? labels[0] : labels[1]}
    </Badge>
  );
}
